import { createReducer } from '__common/utils/helpers';
import { HistoryActionTypes } from 'actionsConstants';


export const historyState: historyState = {
  panelsSnapshot: [[]],
  index: 0,
  maxHistory: 50,
  canUndo: false,
  canRedo: false,
};

const canUndo = (panelsSnapshot, index) => index + 1 < panelsSnapshot.length;
const canRedo = index => index > 0;

export default {
  history: createReducer(historyState, {
    [HistoryActionTypes.UNDO_HISTORY](state) {
      const newIndex = canUndo(state.panelsSnapshot, state.index) ? state.index + 1 : state.index;

      return {
        ...state,
        index: newIndex,
        canUndo: canUndo(state.panelsSnapshot, newIndex),
        canRedo: canRedo(newIndex),
      };
    },
    [HistoryActionTypes.REDO_HISTORY](state) {
      const newIndex = canRedo(state.index) ? state.index - 1 : state.index;

      return {
        ...state,
        index: newIndex,
        canRedo: canRedo(newIndex),
        canUndo: canUndo(state.panelsSnapshot, newIndex),
      };
    },
    [HistoryActionTypes.PUT_PANELS_IN_HISTORY](state, action) {
      const panelsSnapshot = state.panelsSnapshot.slice(state.index);

      panelsSnapshot.unshift(action.payload.panels);

      while (panelsSnapshot.length > state.maxHistory) {
        panelsSnapshot.pop();
      }

      return {
        ...state,
        panelsSnapshot,
        index: 0,
        canUndo: canUndo(panelsSnapshot, 0),
        canRedo: false,
      };
    },
    [HistoryActionTypes.RESET_HISTORY](state) {
      return {
        ...state,
        index: 0,
        canUndo: canUndo(state.panelsSnapshot, 0),
        canRedo: false,
      };
    },
    [HistoryActionTypes.CLEAR_HISTORY](state) {
      return { 
        panelsSnapshot: [[]],
        index: 0,
        maxHistory: 50,
        canUndo: false,
        canRedo: false,
      };
    },
  }),
};
